let _this;
function hideMessageCenter(e){
  if($(e.target).parents('.right-message-center').length <= 0 && $(e.target).parents('#message-detail').length <= 0){
    _this.show = false;
  }
}
export default {
  data() {
    _this = this;
    return {
      show:false,
      searchParams:{
        isRead:false,
        includeNotProcess:false,
        category:0,
        sortName: 'createTime',
        sortType: 1,
        page:1,
        perPage:500,
        status:[],
        queryNodeId: this.$root.curNodeInfo.isMaster ? null : this.$root.curNodeInfo.syncNodeId
      },
      notifications:[], //通知
      activeTab : 'tab1',
      messageCount:20,
      flag:false,
      lastScrollTop:'',
      isLoading:true,
    }
  },
  mounted() {
    _this = this;
    let tabs = ['tab1', 'tab2'];
    eventBus.$on('realTimeMessageArrived',function(message){
      if( tabs[ message.category ] === _this.activeTab ){
        if(_this.searchParams === 0){
          _this.$root.allUnreadMessage.push(message);
        }else{
          _this.$root.allUnreadMessage.unshift(message);
        }
      }
    });
    $(document).bind('click', hideMessageCenter);
  },
  beforeDestroy(){
    $(document).unbind('click', hideMessageCenter);
    eventBus.$off('realTimeMessageArrived');
    eventBus.$off('updateMsgList');
  },
  methods: {
    // 打开消息中心
    open:function(){
      if(_this.$root.adminInfo.permissionCodes.indexOf('M_MyAlarm') <= -1 ){
        _this.activeTab  =  'tab2'
        _this.searchParams.category = 1;
      }
      if(_this.$root.adminInfo.permissionCodes.indexOf('M_MyAlarm') <= -1 && _this.$root.adminInfo.permissionCodes.indexOf('M_MyNotification') <= -1 ){
        _this.activeTab  =  'tab3'
        _this.searchParams.category = 2;
      }
      this.getMessageList();
      this.show = true;
    },
    getMessageList:function(){
      /*获取当前的时间*/
      let date = this.moment(new Date(), 'YYYY-MM-DD').format(_this.$root.Time[_this.$root.Time.type].typeDateStr);
      _this.searchParams.startTime = _this.common.formatDate(date + ' 00:00:00',_this.$root.Time[_this.$root.Time.type].typeTime,2);
      _this.searchParams.endTime = _this.common.formatDate(date + ' 23:59:59',_this.$root.Time[_this.$root.Time.type].typeTime,2);
      _this.isLoading = true;
      let category = _this.searchParams.category;
      if(category == 0){
        this.searchParams.statuses = [10,11,15]
      }else if(category == 1){
        this.searchParams.statuses = [10,15]
      }else if(category == 2){
        this.searchParams.statuses = [10,16]
      }
          
      let tabs = ['tab1', 'tab2', 'tab3'];
      this.$ajax.post('IncidentRecord/PaginateMyself', _this.searchParams, {headers: {noLoading: _this.ApiService.refreshToken !== ''}}).then(function (res) {
        if (_this.activeTab !== tabs[category]) { // 过滤无效的请求数据，防止覆盖当前类型数据
          return;
        }
        if (res.data.success) {

          _this.isLoading = false;
          _this.$root.allUnreadMessage = res.data.data.items;
          _this.$forceUpdate();
        } else {
          _this.isLoading = false;
          _this.$root.allUnreadMessage = [];
        }
      }).catch(() => {
        _this.isLoading = false;
      });
    },
    // 切换tab
    changeTab:function(tab){
      this.searchParams.sortType = 1;
      this.searchParams.page = 1;
      if (tab === 'tab1') {
        this.searchParams.category = 0;
      } else if (tab === 'tab2') {
        this.searchParams.category = 1;
      } else if (tab === 'tab3') {
        this.searchParams.category = 2;
      }
      _this.getMessageList();
      this.activeTab = tab;
    },
    /** Message **/
    // 打开转发 消息modal
    openForwardMessage:function (id) {
      _this.forwardInfo.id = id;
      eventBus.$emit("forwardMsg",id);
    },
    //查看消息详情
    showMessageDetail:function (data, isPlayVideo) {
      if (isPlayVideo) {
        eventBus.$emit('msgDetail', data, 1,false, 0, false, false, false, true,false,false);
      } else {
        eventBus.$emit('msgDetail', data, 0, true, 1,false, false, false, true,false,false);
      }
    },
    //处理消息
    processMsg:function (data) {
      if(!this.$root.isESOPMode){
        if (data.handleType !== 1) {
          return;
        }
        eventBus.$emit('msgDetail', data, 2, true, 3, false, false, 2);
      }else if(this.$route.path == '/incidentProcess'){
        if(this.activeTab == 'tab2'){
          eventBus.$emit('msgDetail', data, 2, true, 3, false, false, 1);
        }
        if(this.activeTab == 'tab3'){
          eventBus.$emit('msgDetail', data, 2, true, 3, false, false, 2);
        }
        if(this.activeTab == 'tab1'){
          this.$router.replace({ path: '/empty' }).then(() => {
            this.$router.replace({ name: 'Process', params: { incident: JSON.stringify(data) } });
          }).catch(() => {
            console.error('Failed to navigate to /empty');
          });
        }
      }else{
        if(this.activeTab == 'tab1'){
          this.$router.push({name:'Process',params:{incident:JSON.stringify(data)}})
        }
        if(this.activeTab == 'tab2'){
          eventBus.$emit('msgDetail', data, 2, true, 3, false, false, 1);
        }
        if(this.activeTab == 'tab3'){
          eventBus.$emit('msgDetail', data, 2, true, 3, false, false, 2);
        }
      }
    },
    //对最新消息进行排序
    getMessageSort:function(type){
      this.searchParams.sortType = type;
      this.searchParams.page = 1;
      this.getMessageList();
    },
    //更多消息
    moreMessage:function(index){
      let paths = ['/myAlarm', '/myNotification', '/myTask'];
      if( _this.$route.path !== paths[ index ] ){
        _this.$router.push({path: paths[index] });
      }
      _this.show = false;
    },
    handleScroll: function () {
      // 设备/屏幕高度
      let content = $('.message-center-content'); // 滚动区域
      let divHeight = content[0].offsetHeight;
      let scrollTop = content[0].scrollTop; // div 到头部的距离
      let scrollHeight = content[0].scrollHeight; // 滚动条的总高度
      //滚动条到底部的条件
      if((scrollTop + divHeight + 10  >= scrollHeight) && scrollTop > _this.lastScrollTop) {
        _this.flag = true;
        if(_this.messageCount < _this.$root.allUnreadMessage.length){
          _this.messageCount = _this.messageCount + 1;
          $('.message-center-content').animate({scrollTop:scrollTop - 15},20);
          _this.lastScrollTop = scrollTop -15;
        }
      }
      if((scrollTop < 10) && scrollTop < _this.lastScrollTop){
        if(_this.messageCount > 20){
          _this.messageCount = _this.messageCount - 1;
          $('.message-center-content').animate({scrollTop:15},20);
          _this.lastScrollTop = 15;
        }
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/messageCenter.js